// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

type HandlerType = ApiHandler<{
    item: any;
}>;

const XngGaAddOrderEvent: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentBillTo = getCurrentBillToState(state).value;

    const { item } = props.parameter;

    if (state.xGoogleAnalytics.includeAddQuickOrderEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.MY_ACCOUNT_QUICK_ORDER,
            items: [
                {
                    ...item,
                },
            ],
            value: item?.pricing?.unitNetPrice,
            currency: state.context.session.currency?.currencyCode,
            affiliation: currentBillTo?.companyName,
            brand_code: currentBillTo?.properties?.brand,
            exclusive: currentBillTo?.properties?.exclusive,
            group_descr: currentBillTo?.properties?.groupDescription,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

export const chain = [XngGaAddOrderEvent];

const xngGaAddOrderEventEvent = createHandlerChainRunner(chain, "XngGaAddOrderEvent");
export default xngGaAddOrderEventEvent;
